export class Paginator {
  pages: string[] = [];
  currentPage: number = 1;
  totalPages: number;
}
